import './styles.css';
import { useTranslation } from 'react-i18next';
import divinaLogo from '../../../assets/img/divinalogo.webp';
import vermanoLogo from '../../../assets/img/logoVermandoWhite.svg';
import galleryLogo from '../../../assets/img/gallery4.webp';
import farolSEOLogo from '../../../assets/img/farolSEOlogo.webp';
import ayyaLogo from '../../../assets/img/ayyalogo.webp';
import dataCom from '../../../assets/img/datacom_logo.webp';
import arena from '../../../assets/img/arena_logo.webp';
import muller from '../../../assets/img/mullerlogo.webp';
import { trackMatomoEvent } from '../../../utils/matomo';

const CustomersSection = () => {
  const { t } = useTranslation();
  return (
    <section className="customers-section">
      <div className="customers-container">
        <div className="section-title-container">
          <div className="line"></div>
          <h2 className="section-title">
            {t('home.customers_title_prefix')}{' '}
            <span className="section-title-accent">
              {t('home.customers_title_accent')}
            </span>{' '}
            {t('home.customers_title_suffix')}
          </h2>
          <div className="line"></div>
        </div>

        <div className="logos-grid">
          <a
            href="https://www.divina.ch/de"
            className="logo-item"
            onClick={() =>
              trackMatomoEvent('Outbound', 'click', 'Customer Divina')
            }
          >
            <img
              src={divinaLogo}
              alt="Logo Divina of Switzerland"
              fetchPriority="low"
              decoding="async"
              loading="lazy"
            />
          </a>

          <a
            href="https://www.hausheld.ch/"
            className="logo-item"
            onClick={() =>
              trackMatomoEvent('Outbound', 'click', 'Customer Vermando')
            }
          >
            <img
              src={vermanoLogo}
              alt="Logo Vermano"
              fetchPriority="low"
              decoding="async"
              loading="lazy"
            />
          </a>
          <a
            href="https://www.galeriegleis4.com/en/gallery-gleis4/"
            className="logo-item"
            onClick={() =>
              trackMatomoEvent('Outbound', 'click', 'Customer Gallery Gleis 4')
            }
          >
            <img
              src={galleryLogo}
              alt="Logo Gallery4"
              fetchPriority="low"
              decoding="async"
              loading="lazy"
            />
          </a>
          <a
            href="https://datacom.ch/"
            className="logo-item"
            onClick={() =>
              trackMatomoEvent('Outbound', 'click', 'Customer DataCom')
            }
          >
            <img
              src={dataCom}
              alt="Logo DataCom"
              fetchPriority="low"
              decoding="async"
              loading="lazy"
            />
          </a>
          <a
            href="https://www.sport1001.ch/"
            className="logo-item"
            onClick={() =>
              trackMatomoEvent('Outbound', 'click', 'Customer Sport 1001')
            }
          >
            <img
              src={arena}
              alt="Logo Arena"
              fetchPriority="low"
              decoding="async"
              loading="lazy"
            />
          </a>
          <a
            href="https://farol-seo.com/"
            className="logo-item"
            onClick={() =>
              trackMatomoEvent('Outbound', 'click', 'Customer Farol SEO')
            }
          >
            <img
              src={farolSEOLogo}
              alt="Logo FarolSEO"
              fetchPriority="low"
              decoding="async"
              loading="lazy"
            />
          </a>
          <a
            href="https://ayya.ch/"
            className="logo-item"
            onClick={() =>
              trackMatomoEvent('Outbound', 'click', 'Customer AYYA')
            }
          >
            <img
              src={ayyaLogo}
              alt="Logo AYYA"
              fetchPriority="low"
              decoding="async"
              loading="lazy"
            />
          </a>
          <a
            href="https://mueller-handarbeiten.ch/"
            className="logo-item"
            onClick={() =>
              trackMatomoEvent('Outbound', 'click', 'Customer Mueller')
            }
          >
            <img
              src={muller}
              alt="Logo Muller"
              fetchPriority="low"
              decoding="async"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CustomersSection;
